<template>
  <div class="custom-form-select cursor-pointer">
    <div
      class="custom-form-select__selected closed"
      @click="showOptions = !showOptions"
    >
      <p>{{ selectedOption }}</p>
      <span>
        <svg
          data-v-17902353=""
          width="14"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-17902353=""
            d="M1 1.03467L5 5.03467L9 1.03467"
            stroke="#000"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </span>
    </div>
    <transition name="select-options">
      <div class="custom-form-select__options" v-if="showOptions">
        <div
          class="custom-form-select__option"
          :class="{ active: selectedOption == 'Reactivate' }"
          @click="selectOption('Reactivate')"
        >
          <p>Reactivate Selected</p>
        </div>
        <div
          :class="{ active: selectedOption == 'Delete' }"
          @click="selectOption('Delete')"
          class="custom-form-select__option"
        >
          <p>Delete Selected</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: "Reactivate",
      showOptions: false,
    };
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
      this.showOptions = false;
      this.$emit("select", this.selectedOption);
    },
  },
};
</script>

<style scoped>
.custom-form-select__selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.5px solid #f8ad91;
  border-radius: 4px;
  padding: 0.45rem 0.75rem;
  width: 12rem;
  min-height: 2.25rem;
  background: #FCC210;
}
.custom-form-select__options {
  position: absolute;
  width: 12rem;
  background-color: #ffffff;
  z-index: 999;
  /* border: 0.5px solid #f8ad91; */
  box-shadow:  0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  padding: 0.45rem 0.35rem;
  margin-top: 1rem;
  font-size: 0.9rem;
}
.custom-form-select__option {
  padding: 0.5rem 0.35rem;
}
.custom-form-select__option.hover {
  background: #FCC210;
}
.custom-form-select__option.active {
  background: #FCC210;
  border-radius: 3px;
  /* color: #ffffff; */
}
.select-options-enter,
.select-options-leave-to {
  opacity: 0;
  transform: translateY(-20%);
}
.select-options-enter-to,
.select-options-leave {
  opacity: 1;
  transform: translateY(0);
}
.select-options-enter-active,
.select-options-leave-active {
  transition: all ease 0.4s;
}
@media screen and (max-width: 768px) {
  .custom-form-select__selected {
    width: 100%;
  }
}
</style>
